import { render, staticRenderFns } from "./SongDetailView.vue?vue&type=template&id=740b92d4&scoped=true"
import script from "./SongDetailView.vue?vue&type=script&lang=ts"
export * from "./SongDetailView.vue?vue&type=script&lang=ts"
import style0 from "./SongDetailView.vue?vue&type=style&index=0&id=740b92d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740b92d4",
  null
  
)

export default component.exports